import { useEffect, useState } from "react"
import { debounce } from "../utils"

export const useUserLastActivity = () => {
  const [lastActivity, setLastActivity] = useState(Date.now())

  useEffect(() => {
    // Update the last activity timestamp based on the user interaction with the page
    const updateLastActivity = debounce(() => setLastActivity(Date.now()))

    const events = ["click", "scroll", "mousemove", "keydown", "resize"]
    events.forEach(event => window.addEventListener(event, updateLastActivity))
    return () => {
      events.forEach(event =>
        window.removeEventListener(event, updateLastActivity)
      )
    }
  }, [])

  return lastActivity
}
